<ng-container [ngSwitch]="action">
  <ng-container *ngSwitchCase="'resetPassword'">
    <sidkik-password-reset></sidkik-password-reset>
  </ng-container>
</ng-container>